import { View, Text, ScrollView, ImageBackground, Image } from 'react-native'
import React, { useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Row, Table } from 'react-native-table-component';
import GlobalStyles from './../style';
import sortBestPlayers from '../sortBestPlayers';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import { useLayoutEffect } from 'react';
import { useNavigation } from '@react-navigation/native';

let lang = undefined;

const BestPlayers = () => {
	const navigation = useNavigation();

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitle: transl('General.mejoresJugadores', lang)
		})
	}, []);

	//receivedData
	const [value, setvalue] = useState('');
	const readValue = () => {
		AsyncStorage.getItem('equipos')
			.then((value) => {
				setvalue(value)
				calculateBestPlayers(value)
			})
	}
	readValue()

	lang = dr.idiomas[useSelector((state) => state.language)].value

	return (
		<View style={{ flex: 1 }}>
			<ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{ flex: 1 }}>
				<ScrollView>
					<View>
						<View style={{ flex: 1, justifyContent: 'center', marginTop: 70 }}>
							<View>
								<Text style={GlobalStyles.textForTitleScreen}>{transl('BestPlayers.mejoresJugadores', lang)}</Text>
							</View>
						</View>
						{calculateBestPlayers(value)}
					</View>
				</ScrollView>
			</ImageBackground>
		</View>
	)

	function calculateBestPlayers(data) {
		if (data === undefined || !data) return <Image style={{ width: 400, height: 400 * 0.6 }} source={require('./../img/loading.gif')} />
		if (typeof data != "object") data = data != null ? JSON.parse(data) : null

		data.teams.push(data.teams.shift());
		let jornadaReal = data.others.siguientePartido
		if (data.others.vecesTodosLosPartidosHechos % 2) jornadaReal += 19
		let updatedPlayers = [];
		data.teams.forEach((team) => {
			team.players.forEach(player => {
				updatedPlayers.push({
					...player,
					team: team.name,
					teamId: team.id
				});
			});
		});

		let state = {
			tableHead: [transl('Roster.nombre', lang), 'N/A', transl('Statistics.partidosJugados', lang), transl('League.equipo', lang), transl('Statistics.edad', lang)],
			widthArr: [130, 70, 70, 140, 40]
		}

		//mejores goleadores
		state.tableHead[1] = transl('Statistics.goles', lang)
		const state1 = JSON.parse(JSON.stringify(state));
		const playersGoals = sortBestPlayers(updatedPlayers, 1, jornadaReal)
		let tenBestGoals = []
		for (let i = 0; i < playersGoals.length; i++) {
			let player = []
			player.push(playersGoals[i].name)
			player.push(playersGoals[i].stats.goals)
			player.push(playersGoals[i].stats.gamesLeague.gAsChaser)
			player.push(playersGoals[i].team)
			player.push(playersGoals[i].age)

			tenBestGoals.push(<Row
				key={i}
				data={player}
				widthArr={state1.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersGoals).s}
			/>)
		}
		const goalsTable = getViewAllTable(transl('BestPlayers.masGoles', lang), tenBestGoals, state1)

		//mas asistencias
		state.tableHead[1] = transl('Statistics.asistencias', lang)
		const state2 = JSON.parse(JSON.stringify(state));
		const playersAssists = sortBestPlayers(updatedPlayers, 2, jornadaReal)
		let tenBestAssists = []
		for (let i = 0; i < playersAssists.length; i++) {
			let player = []
			player.push(playersAssists[i].name)
			player.push(playersAssists[i].stats.assists)
			player.push(playersAssists[i].stats.gamesLeague.gAsChaser)
			player.push(playersAssists[i].team)
			player.push(playersAssists[i].age)

			tenBestAssists.push(<Row
				key={i}
				data={player}
				widthArr={state2.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersAssists).s}
			/>)
		}
		const assistsTable = getViewAllTable(transl('BestPlayers.masAsistencias', lang), tenBestAssists, state2)

		//mas rebotes
		state.tableHead[1] = transl('BestPlayers.rebotes', lang)
		const state3 = JSON.parse(JSON.stringify(state));
		const playersRebounds = sortBestPlayers(updatedPlayers, 3, jornadaReal)
		let tenBestRebounds = []
		for (let i = 0; i < playersRebounds.length; i++) {
			let player = []
			player.push(playersRebounds[i].name)
			player.push(playersRebounds[i].stats.offensiveRebounds + playersRebounds[i].stats.defensiveRebounds)
			player.push(playersRebounds[i].stats.gamesLeague.gAsChaser + playersRebounds[i].stats.gamesLeague.gAsKeeper)
			player.push(playersRebounds[i].team)
			player.push(playersRebounds[i].age)

			tenBestRebounds.push(<Row
				key={i}
				data={player}
				widthArr={state3.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersRebounds).s}
			/>)
		}
		const reboundsTable = getViewAllTable(transl('BestPlayers.masRebotes', lang), tenBestRebounds, state3)

		//mas progresiones
		state.tableHead[1] = transl('Statistics.progresiones', lang)
		const state11 = JSON.parse(JSON.stringify(state));
		const playersProgressions = sortBestPlayers(updatedPlayers, 12, jornadaReal)
		let tenBestProgressions= []
		for (let i = 0; i < playersProgressions.length; i++) {
			let player = []
			player.push(playersProgressions[i].name)
			player.push(playersProgressions[i].stats.offensiveRebounds + playersProgressions[i].stats.defensiveRebounds)
			player.push(playersProgressions[i].stats.gamesLeague.gAsChaser + playersProgressions[i].stats.gamesLeague.gAsKeeper)
			player.push(playersProgressions[i].team)
			player.push(playersProgressions[i].age)

			tenBestProgressions.push(<Row
				key={i}
				data={player}
				widthArr={state11.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersProgressions).s}
			/>)
		}
		const progressionsTable = getViewAllTable(transl('BestPlayers.masProgresiones', lang), tenBestProgressions, state11)

		//menos goles encajados (con 65% minimo de partidos)(o con paradas, hacer porcentaje tambien, ademas de partidos) condededGoals and saves
		state.tableHead[1] = transl('Statistics.golesEncajados', lang)
		const state4 = JSON.parse(JSON.stringify(state));
		const playersZamora = sortBestPlayers(updatedPlayers, 4, jornadaReal)
		let tenBestZamora = []
		for (let i = 0; i < playersZamora.length; i++) {
			let player = []
			player.push(playersZamora[i].name)
			player.push((playersZamora[i].stats.concededGoals / (playersZamora[i].stats.gamesLeague.gAsKeeper)).toFixed(2))
			player.push(playersZamora[i].stats.gamesLeague.gAsKeeper)
			player.push(playersZamora[i].team)
			player.push(playersZamora[i].age)

			tenBestZamora.push(<Row
				key={i}
				data={player}
				widthArr={state4.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersZamora).s}
			/>)
		}
		const zamoraTable = getViewAllTable(transl('BestPlayers.menosGolesEncajados', lang), tenBestZamora, state4, transl('BestPlayers.minimoDePartidos', lang, [Math.round(jornadaReal * 0.65)]))

		//mas paradas (paradas/(paradas+golesEncajados))
		state.tableHead[1] = transl('BestPlayers.pParadas', lang)
		const state5 = JSON.parse(JSON.stringify(state));
		const playersSaves = sortBestPlayers(updatedPlayers, 5, jornadaReal)
		let tenBestSaves = []
		for (let i = 0; i < playersSaves.length; i++) {
			let player = []
			player.push(playersSaves[i].name)
			player.push(((playersSaves[i].stats.saves * 100) / (playersSaves[i].stats.saves + playersSaves[i].stats.concededGoals)).toFixed(2))
			player.push(playersSaves[i].stats.gamesLeague.gAsKeeper)
			player.push(playersSaves[i].team)
			player.push(playersSaves[i].age)

			tenBestSaves.push(<Row
				key={i}
				data={player}
				widthArr={state5.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersSaves).s}
			/>)
		}
		const savesTable = getViewAllTable(transl('BestPlayers.paradasCada100', lang), tenBestSaves, state5, transl('BestPlayers.minimoDePartidos', lang, [Math.round(jornadaReal * 0.65)]))

		//snitches capturadas
		state.tableHead[1] = transl('Statistics.snitchs', lang)
		const state6 = JSON.parse(JSON.stringify(state));
		const playersSnitchs = sortBestPlayers(updatedPlayers, 6, jornadaReal)
		let tenBestSnitchs = []
		for (let i = 0; i < playersSnitchs.length; i++) {
			let player = []
			player.push(playersSnitchs[i].name)
			player.push(playersSnitchs[i].stats.snitchs)
			player.push(playersSnitchs[i].stats.gamesLeague.gAsSeeker)
			player.push(playersSnitchs[i].team)
			player.push(playersSnitchs[i].age)

			tenBestSnitchs.push(<Row
				key={i}
				data={player}
				widthArr={state6.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersSnitchs).s}
			/>)
		}
		const snitchsTable = getViewAllTable(transl('BestPlayers.masSnitchs', lang), tenBestSnitchs, state6)

		//bludgers golpeadas
		state.tableHead[1] = transl('BestPlayers.bludgers', lang)
		const state7 = JSON.parse(JSON.stringify(state));
		const playersBludgers = sortBestPlayers(updatedPlayers, 7, jornadaReal)
		let tenBestBludgers = []
		for (let i = 0; i < playersBludgers.length; i++) {
			let player = []
			player.push(playersBludgers[i].name)
			player.push(playersBludgers[i].stats.bludgersSaves + playersBludgers[i].stats.bludgersThrown)
			player.push(playersBludgers[i].stats.gamesLeague.gAsBeater)
			player.push(playersBludgers[i].team)
			player.push(playersBludgers[i].age)

			tenBestBludgers.push(<Row
				key={i}
				data={player}
				widthArr={state7.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersBludgers).s}
			/>)
		}
		const bludgersTable = getViewAllTable(transl('BestPlayers.masBludgers', lang), tenBestBludgers, state7)

		//balones robados, regates y progresiones (good plays)
		state.tableHead[1] = transl('BestPlayers.buenasJugadas', lang)
		const state8 = JSON.parse(JSON.stringify(state));
		const playersChaser = sortBestPlayers(updatedPlayers, 8, jornadaReal)
		let tenBestChaser = []
		for (let i = 0; i < playersChaser.length; i++) {
			let player = []
			player.push(playersChaser[i].name)
			player.push(playersChaser[i].stats.dribbles + playersChaser[i].stats.bStolen)
			player.push(playersChaser[i].stats.gamesLeague.gAsChaser)
			player.push(playersChaser[i].team)
			player.push(playersChaser[i].age)

			tenBestChaser.push(<Row
				key={i}
				data={player}
				widthArr={state8.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersChaser).s}
			/>)
		}
		const chaserTable = getViewAllTable(transl('BestPlayers.masRegatesYBalones', lang), tenBestChaser, state8)

		//peores jugadores de la liga
		state.tableHead[1] = transl('BestPlayers.malasJugadas', lang)
		const state9 = JSON.parse(JSON.stringify(state));
		const playersWorst = sortBestPlayers(updatedPlayers, 9, jornadaReal)
		let tenBestWorst = []
		for (let i = 0; i < playersWorst.length; i++) {
			let player = []
			player.push(playersWorst[i].name)
			player.push(playersWorst[i].stats.faults + playersWorst[i].stats.bLost)
			player.push(playersWorst[i].stats.gamesLeague.gAsChaser)
			player.push(playersWorst[i].team)
			player.push(playersWorst[i].age)

			tenBestWorst.push(<Row
				key={i}
				data={player}
				widthArr={state9.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersWorst).s}
			/>)
		}
		const worstTable = getViewAllTable(transl('BestPlayers.peoresJugadores', lang), tenBestWorst, state9)

		//mejores jugadores de la liga (Trofeo MVP)
		state.tableHead[1] = transl('BestPlayers.accionesOfDef', lang)
		const state10 = JSON.parse(JSON.stringify(state));
		const playersMVP = sortBestPlayers(updatedPlayers, 10, jornadaReal)
		let tenBestMVP = []
		for (let i = 0; i < playersMVP.length; i++) {
			let player = []
			player.push(playersMVP[i].name)
			player.push(playersMVP[i].stats.goals + playersMVP[i].stats.assists + playersMVP[i].stats.defensiveRebounds + playersMVP[i].stats.offensiveRebounds + playersMVP[i].stats.dribbles + playersMVP[i].stats.bStolen)
			player.push(playersMVP[i].stats.gamesLeague.gAsChaser + playersMVP[i].stats.gamesLeague.gAsKeeper)
			player.push(playersMVP[i].team)
			player.push(playersMVP[i].age)

			tenBestMVP.push(<Row
				key={i}
				data={player}
				widthArr={state10.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersMVP).s}
			/>)
		}
		const mvpTable = getViewAllTable(transl('BestPlayers.mvps', lang), tenBestMVP, state10)

		//mejores jugadores menores de 21
		const playersKopa = sortBestPlayers(updatedPlayers, 11, jornadaReal)
		let tenBestKopa = []
		for (let i = 0; i < playersKopa.length; i++) {
			let player = []
			player.push(playersKopa[i].name)
			player.push(playersKopa[i].stats.goals + playersKopa[i].stats.assists + playersKopa[i].stats.defensiveRebounds + playersKopa[i].stats.offensiveRebounds + playersKopa[i].stats.dribbles + playersKopa[i].stats.bStolen)
			player.push(playersKopa[i].stats.gamesLeague.gAsChaser + playersKopa[i].stats.gamesLeague.gAsKeeper)
			player.push(playersKopa[i].team)
			player.push(playersKopa[i].age)

			tenBestKopa.push(<Row
				key={i}
				data={player}
				widthArr={state.widthArr}
				textStyle={{ textAlign: 'center' }}
				style={rowStyle(i, playersKopa).s}
			/>)
		}
		const kopaTable = getViewAllTable(transl('BestPlayers.mejores21', lang), tenBestKopa, state)

		return <View>
			<View style={{ marginTop: 50 }}>
				{goalsTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{assistsTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{reboundsTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{progressionsTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{zamoraTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{savesTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{snitchsTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{bludgersTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{chaserTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{worstTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{mvpTable}
			</View>
			<View style={{ marginTop: 50 }}>
				{kopaTable}
			</View>
		</View>
	}
	function tableEmpty() {
		return <Row
			key={1}
			data={[transl('BestPlayers.noHayJugadores', lang)]}
			flexArr={[5]}
			textStyle={{ textAlign: 'center' }}
			style={{ backgroundColor: '#ffffff' }}
		/>
	}
	function getViewAllTable(text, tenBest, state, subText = '') {
		return <View>
			<Text style={[GlobalStyles.textH2]}>{text}</Text>
			<Text style={{ textAlign: 'center' }}>{subText}</Text>
			<ScrollView horizontal={true}>
				<View style={{ marginTop: 15 }}>
					<Table borderStyle={{ borderWidth: 1, borderColor: '#C1C0B9' }}>
						<Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text} />
					</Table>
					<Table>{tenBest.length != 0 ? tenBest : tableEmpty()}</Table>
				</View>
			</ScrollView>
		</View>
	}
}

const styles = {
	container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
	header: { height: 50, backgroundColor: '#f2f2f2' },
	text: { textAlign: 'center', fontWeight: 'bold', fontSize: 13 },
	row: { height: 40, backgroundColor: '#E7E6E1' }
};

const rowStyle = (i, up) => {
	return {
		s: [
			i % 2 && { backgroundColor: '#ffffff' },
			!(i % 2) && { backgroundColor: '#f2f2f2' },
			up[i].teamId == 1 && i % 2 && { backgroundColor: '#ffffb3', borderColor: '#000', borderWidth: 1 },
			up[i].teamId == 1 && !(i % 2) && { backgroundColor: '#ffff80', borderColor: '#000', borderWidth: 1 }
		]
	}
}

export default BestPlayers